// import jwtDecode from 'jwt-decode';
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ListAllTickets from "../../Pages/SAV/TicketList/ListAllTickets/ListAllTickets";
import SAVIcon from "../../GlobalComponents/IconComponents/SAVIcon";
import { setLastActiveTab } from "../../ReduxTLK/features/Tabs/TabsSlice";
import { useDispatch } from "react-redux";
import { NavContext } from "../../App";
import { decryptData } from "../../utils/cryptoUtils";

function AutoLoginWithToken() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const context = useContext(NavContext);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const encryptedData = queryParams.get("encryptedData");

    if (encryptedData) {
      try {
        // Decrypt
        const decrypted = decryptData(encryptedData);

        // Save token and user info to localStorage
        const bearerToken = "Bearer " + decrypted?.user?.userToken;
        localStorage.setItem("TokenStored", bearerToken);
        localStorage.setItem("Token", decrypted?.user?.userToken);
        localStorage.setItem("userId", decrypted?.user?.id || decrypted?.id);
        localStorage.setItem(
          "userlastName",
          decrypted?.user?.lastName || decrypted?.user?.firstName
        );

        localStorage.setItem("iframeAutoLogin", "true");

        // // SignalR and context setup
        // context.connectToSignalR();
        // context.setNotifcationHub("SAV");
        // context.setLogged(true);
        // context.setTabs([
        //   {
        //     id: 3,
        //     label: "Tous les tickets",
        //     component: <ListAllTickets />,
        //     closeable: false,
        //     icon: <SAVIcon />,
        //     collapse: false,
        //     invisible: false,
        //   },
        // ]);
        // context.setActiveTab(3);
        // dispatch(setLastActiveTab(3));

        // // Redirect to dashboard
        // navigate("/dashboard");
      } catch (err) {
        console.error("Invalid token", err);
        // Optionally redirect to login
      }
    } else {
      localStorage.setItem("iframeAutoLogin", "false");
    }
  }, []);

  return null;
}

export default AutoLoginWithToken;
